import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import images from "../../images";
import Copyright from "../../layout/Copyright/Copyright";
import { FormFieldSigIn } from "../../components/common/Input/InputSignIn";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  // Combined state for password visibility
  const [hidePassword, setHidePassword] = useState({
    password: true,
    confirmPassword: true,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleResetPassword = async () => {
    if (formData.password !== formData.confirmPassword) {
      toast.error(t("resetPassword.passwordNotMatch"));
      return;
    }

    try {
      // Simulation successful
      toast.success(t("resetPassword.passwordResetSuccess"));
      navigate("/sign-in");
    } catch (err) {
      toast.error(t("resetPassword.passwordResetFailed"));
      // console.error("Error:", err);
    }
  };

  const togglePasswordVisibility = (field) => {
    setHidePassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  return (
    <main className="mx-auto w-full bg-yellow-50 max-w-[480px]">
      <Helmet>
        <meta name="theme-color" content="#fefce8" />
      </Helmet>
      <section className="flex justify-center items-center w-full h-[300px]">
        <img src={images.LogoLogin} className="w-[180px]" alt="Logo" />
      </section>
      <section className="flex flex-col justify-between px-4 py-6 w-full bg-white min-h-[calc(100dvh-300px)] rounded-t-[20px] shadow-[0px_0px_4px_rgba(0,0,0,0.08)]">
        <div className="flex flex-col items-center justify-center w-full max-w-[340px] mx-auto">
          <section className="w-full text-center">
            <div className="flex flex-col items-center">
              <h1 className="text-3xl font-bold text-gray-800">
                {t("resetPassword.resetYourPassword")}
              </h1>
              <div className="mt-3">
                <span className="inline-block px-3 py-1.5 text-xs text-amber-400 bg-yellow-50 rounded-xl">
                  {t("resetPassword.enterNewPassword")}
                </span>
              </div>
            </div>
          </section>

          <div className="flex flex-col w-full text-sm text-neutral-500">
            <FormFieldSigIn
              placeholder={t("resetPassword.newPassword")}
              icon={images.KeyIcon}
              type={hidePassword.password ? "password" : "text"}
              handleRightIcon={() => togglePasswordVisibility("password")}
              rightIcon={images.EyesIcon}
              name="password"
              value={formData.password}
              onChange={handleInputChange}
            />

            <FormFieldSigIn
              placeholder={t("resetPassword.confirmPassword")}
              icon={images.KeyIcon}
              type={hidePassword.confirmPassword ? "password" : "text"}
              handleRightIcon={() =>
                togglePasswordVisibility("confirmPassword")
              }
              rightIcon={images.EyesIcon}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleInputChange}
            />

            <button
              onClick={handleResetPassword}
              className="w-full px-4 py-3 mt-5 text-lg font-semibold text-white bg-[#3F54DF] rounded-xl"
            >
              {t("resetPassword.resetPassword")}
            </button>

            <p className="mt-5 w-full text-center text-sm">
              <span
                style={{
                  fontFamily:
                    "Figtree, -apple-system, Roboto, Helvetica, sans-serif",
                  fontWeight: 400,
                  color: "rgba(120,122,122,1)",
                }}
              >
                {t("resetPassword.rememberPassword")}
              </span>
              <span
                onClick={() => navigate("/sign-in")}
                style={{
                  fontFamily:
                    "Figtree, -apple-system, Roboto, Helvetica, sans-serif",
                  fontWeight: 700,
                  color: "rgba(63,84,223,1)",
                  cursor: "pointer",
                }}
              >
                {t("resetPassword.signIn")}
              </span>
            </p>
          </div>
        </div>
        <div className="flex justify-center">
          <Copyright />
        </div>
      </section>
    </main>
  );
}
